<template>
  <el-container v-if="!$route.query.appid">
    <el-header class="!h-[56] min-w-[1200] head pl-[0] flex justify-between bg-[#00152a] items-center pr-[32]">
      <div class="flex items-center">
        <p class="h-[56] w-[56] bg-[theme] rounded-tr-[12] text-center leading-[56]" v-if="['yi-bin'].indexOf(conf.city) == -1">
          <i v-if="conf.logoIcon" class="iconfont-logo t-[#fff] t-[40]" :class="conf.logoIcon"></i>
          <img v-else class="w-[40]" :src="getCityAssetsFile('logo.png')" alt="" />
        </p>
        <p class="t-[#fff] pl-[12] t-[16] font-700 ff-[yiBin]">{{ conf.name }}</p>
      </div>
      <div class="flex t-[#fff]">
        <div class="relative mr-[36] cursor-pointer" @click="push('/notify/list')">
          <i class="icon">&#xe62d;</i>
          <span>消息</span>

          <span class="absolute w-[16] text-center leading-[16] h-[16] top-[-10] right-[-10] t-[#fff] bg-[#FF0000] rounded-[100] t-[10]" v-show="messageCount">{{ messageCount > 100 ? "99+" : messageCount }}</span>
        </div>
        <div class="relative mr-[36] cursor-pointer" @click="wopen(ENV.official)">
          <i class="icon">&#xe67d;</i>
          <span>官网</span>
        </div>
        <div class="relative mr-[80] cursor-pointer">
          <el-popover placement="bottom-end" width="315" trigger="hover" popper-class="popper-phone">
            <div slot="reference" class="item cursor-pointer">
              <i class="icon">&#xe624;</i>
              <span>客服</span>
            </div>
            <div class="">
              <div>
                <div class="flex justify-start">
                  <div class="flex justify-start items-center h-[20]">
                    <img class="mr-[4]" width="16" height="16" src="@/assets/img/xiaojin/phone.png" alt="" />
                    <span class="t-[14]" style="white-space: nowrap">客服热线：</span>
                  </div>
                  <span class="t-[14] t-[#303133]">{{ contact.telephone || "-" }}</span>
                </div>
                <div class="flex justify-start">
                  <div class="flex justify-start items-center h-[20]">
                    <img class="mr-[4]" width="16" height="16" src="@/assets/img/xiaojin/cell.png" alt="" />
                    <span class="t-[14]" style="white-space: nowrap">服务时间：</span>
                  </div>
                  <span class="t-[14] t-[#303133]">{{ contact.customerServiceTime || "-" }}</span>
                </div>
              </div>
              <div class="flex text-center pt-[10]">
                <div class="pr-[10]" v-if="contact.officialQrCode">
                  <p><img :src="contact.officialQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">公众号</p>
                </div>
                <div class="pr-[10]" v-if="contact.wechatQrCode">
                  <p><img :src="contact.wechatQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">客服微信</p>
                </div>
                <div v-if="contact.appletQrCode">
                  <p><img :src="contact.appletQrCode" class="w-[84] h-[84]" alt="" /></p>
                  <p class="pt-[4] t-[12]">小程序</p>
                </div>
              </div>
            </div>
          </el-popover>
        </div>

        <el-dropdown class="headimg-box" @command="handleCommand">
          <div class="flex items-center cursor-pointer">
            <p class="px-[4] t-[14] t-[#fff]">
              {{ current.user && current.user.realName }}
            </p>
            <p class=""><i class="icon t-[#fff]">&#xe747;</i></p>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="info">个人信息</el-dropdown-item>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-main class="min-w-[1024]" :style="contentStyle">
        <div class="pl-[16] pr-[16] pb-[16]" :class="{ 'pt-[8]': $route.name != 'index' }">
          <transition name="el-zoom-in-top" v-if="tips.msg">
            <div class="mt-[10]" v-show="tips.msg">
              <el-alert
                @close="
                  () => {
                    tips.msg = '';
                    tips.type = 'error';
                  }
                "
                :title="tips.msg"
                :type="tips.type"
                show-icon
              >
              </el-alert>
            </div>
          </transition>
          <router-view v-loading="showLoading" :key="$route.fullPath" :contact="contact" />
        </div>
      </el-main>
    </el-container>
    <!-- <dg-help></dg-help> -->
    <dgLimitedDiglog v-if="showLimitedDiglog"></dgLimitedDiglog>
    <dg-xiaojin top="30%" right="0" showblank="open"></dg-xiaojin>
  </el-container>
  <router-view v-else v-loading="showLoading" :key="$route.fullPath" />
</template>

<script>
import menuJson from "@/assets/js/menu";
// import breadcrumb from "../assets/js/breadcrumb";
import analysisRoute from "@/assets/js/breadcrumbList";
import mixin from "@/assets/js/mixin";
import dgLimitedDiglog from "@/components/dg-limited-diglog.vue";
import { recursiveSearch, isIE, rulTojson } from "@/assets/js/utils";

let childrenArr = [];
menuJson.forEach((el) => {
  if (el.children && el.children.length) {
    childrenArr.push(el.children);
  }
});
let menusStructure = [];
childrenArr.forEach((el) => {
  menusStructure.push({
    paths: recursiveSearch(el, "children", "path"),
    children: el,
  });
});
export default {
  mixins: [mixin],
  components: {
    dgLimitedDiglog,
  },
  data() {
    return {
      indexRedDot: false,
      // contact: {
      //   customerServicePhone: process.config.contact.phone ? process.config.contact.phone : "400-816-1767", // 服务电话
      //   customerServiceTime: "工作日 9:00-18:00", // 服务时间
      //   customerServiceWechatQrcode: require(`@/assets/img/city/${process.config.city}/ke_fu.png`), //客服二维码
      //   wechatPublicQrcode: ['ji-nan', 'fu-yang', 'chi-zhou'].indexOf(config.city) == -1 ? require(`@/assets/img/city/${process.config.city}/gzh.png`) : ''// 公众号
      // },
      contact: {
        customerServiceTime: "工作日 9:00-18:00", // 服务时间
        appletQrCode: "", //小程序码
        gmtCreate: "",
        gmtModified: "",
        id: 0,
        mobile: "", //客服联系方式
        officialQrCode: "", //公众号二维码
        tags: {},
        telephone: "", //座机或固定电话
        version: 0,
        wechatQrCode: "", //客服微信二维码
      },
      messageCount: 0,
      menuIndex: "",
      isH: "",
      menuJson,
      isCollapse: false,
      showLoading: false,

      tips: {
        msg: "",
        type: "error",
      },

      contentStyle: {
        height: window.innerHeight - 60 + "px",
        width: Math.max(window.innerWidth - 200, 1200) + "px",
      },
      current: {
        user: { realName: "" },
      },
      breadcrumbList: [],
      showLimitedDiglog: false,
    };
  },
  watch: {
    $route: {
      handler(to) {
        if (["index", "applyIndex", "orderIndex", "couponIndex"].includes(to.name)) {
          this.showLimitedDiglog = true;
        }

        if (to.fullPath.indexOf("SSOLogin=1") != -1) {
          this.getCurrent();
        }
        // this.routePath = to.path;
        this.menuIndex = to.path;
        let routerQuery = window.localStorage.getItem("routerQuery") ? JSON.parse(window.localStorage.getItem("routerQuery")) : {};
        routerQuery[to.path] = to.query;
        window.localStorage.setItem("routerQuery", JSON.stringify(routerQuery));
        this.$nextTick(() => {
          this.breadcrumbList = analysisRoute(to);
        });
        this.ca_back();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    // getBreadcrumb() {
    //   return breadcrumb[this.$route.fullPath] || breadcrumb[this.$route.path] || [];
    // },
  },
  methods: {
    //获取红点

    selectEventPoster() {
      ajax.post({
        url: "/customer/Integral/eventPoster",
        data: {},
        self: this,
        success: (res) => {
          this.indexRedDot = res.indexRedDot; 
          this.$root.$emit("getEventPoster", res);
        },
      });
    },
    getContact() {
      ajax.post({
        url: "/customer/common/platformServiceDetail",
        data: {},
        self: this,
        success: (res) => {
          this.contact = { ...this.contact, ...res };
        },
      });
    },
    getCurrent() {
      ajax.post({
        url: "/customer/user/current",
        data: {},
        self: this,
        success: (res) => {
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            this.current = JSON.parse(localStorage.getItem("current"));
            // window.fixOpen(window.location.origin,"_self")
          }
        },
      });
    },
    ca_back() {
      if (isIE()) {
        // 判断是否为同意驱动跳转的
        setTimeout(() => {
          if (window.location.pathname.indexOf("ca.html") > -1 && localStorage.getItem("history_url_caSeal")) {
            // window.history.back(-1)
            let rul = localStorage.getItem("history_url_caSeal");
            localStorage.removeItem("history_url_caSeal");
            if (rul.indexOf("#") > -1) {
              rul = rul.split("#")[1];
              let path = rul.split("?")[0];
              this.$router.replace({ path, query: rulTojson(rul) });
            }
          }
        }, 100);
      }
    },
    /**
     * @author 伟健 / 张
     * @name 获取公告未读数量
     * @param
     * @return
     */
    unreadMessageCount() {
      ajax.get({
        url: "/customer/message/unreadMessageCount",
        params: {},
        success: (res) => {
          this.messageCount = res;
        },
      });
    },
    // 没有二级目录的跳转
    directrouter(item, path) {
      if (item.paths) {
        if (item.paths.indexOf(this.menuIndex) != -1) {
          if (this.isH == "") {
            this.isH = path;
          } else {
            this.isH = "";
          }
        } else {
          this.isH = path;
          this.menuIndex = path;
          this.setParentMenu(path);
          this.push({ path });
        }
      } else {
        this.isH = path;
        this.menuIndex = path;
        this.setParentMenu(path);
        this.push({ path });
      }
    },
    setParentMenu(path) {
      this.menuChild = [];
      localStorage.setItem("menuChild", JSON.stringify([]));
      menusStructure.forEach((el) => {
        if (el.paths.indexOf(path) > -1) {
          this.menuChild = el.children;
          localStorage.setItem("menuChild", JSON.stringify(el.children));
        }
      });
    },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      this.$nextTick(() => {
        // this.resize();
      });
    },
    reactiveMenu(pathArrary = []) {
      // 首页
      if (this.$route.path == "/" && pathArrary[0] == "/") {
        return true;
      }
      return pathArrary.indexOf(this.$route.path) > -1;
    },
    handleCommand(command) {
      if (command == "info") {
        this.menuKey = "user";
        this.push({ path: "/user/account/info" });
      }
      if (command == "password") {
        this.push({ path: "/user/account/modifyPasw" });
      }
      if (command == "exit") {
        ajax.post({
          url: "/customer/auth/logout",
          data: {},
          self: this,
          success: (res) => {
            if (res) {
              sessionStorage.removeItem("menuChild");
              this.back({ path: "/login" });
            }
          },
        });
      }
    },
  },
  mounted() {
    if (isIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          let   currentPath = window.location.hash.slice(1);

          if (this.$route.path !== currentPath && this.$route.path.indexOf("/external") > -1) {
            window.location.reload();
          }
        },
        false
      );
      this.ca_back();
    }
    // Mirror.watch("loading_home_open", () => {
    //   this.showLoading = true;
    // });
    // Mirror.watch("loading_home_close", () => {
    //   this.showLoading = false;
    // });
    // let time = null;
    // Mirror.watch(['tips_bus', "tips_el_alert_box_open"], (key, msg) => {
    //   if (this.dgFormDialog) return;
    //   if (typeof msg == "string") {
    //     this.tips.msg = msg;
    //     this.tips.type = "error";
    //   } else if (msg) {
    //     clearInterval(time);
    //     this.tips.msg = msg.msg;
    //     this.tips.type = msg.type;
    //   }
    // });
    // 监听窗口变化
    window.onresize = () => {
      this.contentStyle.height = window.innerHeight - 60 + "px";
      this.contentStyle.width = Math.max(window.innerWidth - 200, 1200) + "px";
    };
  },
  created() {
    this.selectEventPoster();
    this.getContact();

    if (localStorage.getItem("current")) {
      this.current = JSON.parse(localStorage.getItem("current"));
    }
    if (!this.$route.query.appid) {
      this.$root.$on("unreadMessageCount", this.unreadMessageCount);
    }
    this.$root.$on("selectEventPoster", this.selectEventPoster);
  },
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.shadow {
  box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.05);
}

.aside {
  transition: all 0.3s;
}

.aside-box {
  .active {
    background-color: @themeBrightColor10 !important;
    border-radius: 4px;

    span,
    i {
      color: @theme !important;
    }
  }
}

.aside-box-collapse {
  .active {
    background-color: @themeBrightColor10 !important;
    color: @theme !important;
    border-radius: 4px;
  }
}

.el-main {
  padding: 0 !important;
  background-color: #f7f7f9;
}

.popper-class {
  padding: 8px 0 !important;
}

.popoverActive {
  background-color: @themeBrightColor10 !important;
  color: @theme !important;
  border-radius: 4px;
}

.popperclass {
  background-color: @theme;
}
</style>
